var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.75 4.37496H15.5625C15.2668 2.91851 13.9862 1.87183 12.5 1.87183C11.0138 1.87183 9.73325 2.91851 9.4375 4.37496H1.25V5.62496H9.4375C9.73325 7.08141 11.0138 8.12809 12.5 8.12809C13.9862 8.12809 15.2668 7.08141 15.5625 5.62496H18.75V4.37496ZM12.5 6.87496C11.4645 6.87496 10.625 6.03549 10.625 4.99996C10.625 3.96443 11.4645 3.12496 12.5 3.12496C13.5355 3.12496 14.375 3.96443 14.375 4.99996C14.375 6.03549 13.5355 6.87496 12.5 6.87496V6.87496ZM1.25 15.625H4.4375C4.73325 17.0814 6.01382 18.1281 7.5 18.1281C8.98618 18.1281 10.2668 17.0814 10.5625 15.625H18.75V14.375H10.5625C10.2668 12.9185 8.98618 11.8718 7.5 11.8718C6.01382 11.8718 4.73325 12.9185 4.4375 14.375H1.25V15.625ZM5.625 15C5.625 13.9644 6.46447 13.125 7.5 13.125C8.53553 13.125 9.375 13.9644 9.375 15C9.375 16.0355 8.53553 16.875 7.5 16.875C6.46447 16.875 5.625 16.0355 5.625 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.411add956cefd58a9ad7da9630ec366d.svg";
export { ForwardRef as ReactComponent };